import { type RootState } from '../redux-utils';

import intlNameSpace from './intlNameSpace';

const root = (state: RootState) => state[intlNameSpace];

export default root;
